const productNamesMap = {
    'PLANE': 'flight',
    'TRAIN': 'train',
    'MIX_PLANE_TRAIN': 'xfaring',
};

const setProductNameInSession = (transportType) => {
    const productName = productNamesMap[transportType];
    Odigeo.Session.set('productName', productName);
};

module.exports = {
    setProductNameInSession,
};
